"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconWashingRoomFilled = function IconWashingRoomFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.8 18.24C20.8222 18.24 18.8888 18.8265 17.2443 19.9253C15.5998 21.0241 14.3181 22.5859 13.5612 24.4132C12.8043 26.2404 12.6063 28.2511 12.9921 30.1909C13.378 32.1307 14.3304 33.9125 15.7289 35.3111C17.1274 36.7096 18.9093 37.662 20.8491 38.0479C22.7889 38.4337 24.7996 38.2357 26.6268 37.4788C28.4541 36.7219 30.0159 35.4402 31.1147 33.7957C32.2135 32.1512 32.8 30.2178 32.8 28.24C32.8 25.5878 31.7464 23.0443 29.8711 21.1689C27.9957 19.2936 25.4522 18.24 22.8 18.24ZM22.8 35.74C21.3166 35.74 19.8666 35.3001 18.6332 34.476C17.3998 33.6519 16.4386 32.4806 15.8709 31.1101C15.3032 29.7397 15.1547 28.2317 15.4441 26.7768C15.7335 25.322 16.4478 23.9856 17.4967 22.9367C18.5456 21.8878 19.882 21.1735 21.3368 20.8841C22.7917 20.5947 24.2997 20.7433 25.6701 21.3109C27.0406 21.8786 28.2119 22.8399 29.036 24.0732C29.8601 25.3066 30.3 26.7566 30.3 28.24C30.3 29.2249 30.106 30.2002 29.7291 31.1101C29.3522 32.0201 28.7997 32.8469 28.1033 33.5433C27.4069 34.2397 26.5801 34.7922 25.6701 35.1691C24.7602 35.546 23.7849 35.74 22.8 35.74Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8.81C4.5 6.42965 6.42965 4.5 8.81 4.5H41.19C43.5703 4.5 45.5 6.42965 45.5 8.81V41.19C45.5 43.5703 43.5703 45.5 41.19 45.5H8.81C6.42965 45.5 4.5 43.5703 4.5 41.19V8.81ZM7.5 41.19V14H42.5V41.19C42.5 41.9135 41.9135 42.5 41.19 42.5H8.81C8.08651 42.5 7.5 41.9135 7.5 41.19ZM26.6 9.5C26.6 10.3284 25.9284 11 25.1 11C24.2716 11 23.6 10.3284 23.6 9.5C23.6 8.67157 24.2716 8 25.1 8C25.9284 8 26.6 8.67157 26.6 9.5ZM32.1 10.98C32.9284 10.98 33.6 10.3084 33.6 9.48C33.6 8.65157 32.9284 7.98 32.1 7.98C31.2716 7.98 30.6 8.65157 30.6 9.48C30.6 10.3084 31.2716 10.98 32.1 10.98ZM19.6 9.5C19.6 10.3284 18.9284 11 18.1 11C17.2716 11 16.6 10.3284 16.6 9.5C16.6 8.67157 17.2716 8 18.1 8C18.9284 8 19.6 8.67157 19.6 9.5Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.1571 25H35.8429C35.3774 25 35 25.3698 35 25.826V31.174C35 31.6302 35.3774 32 35.8429 32H36.1571C36.6226 32 37 31.6302 37 31.174V25.826C37 25.3698 36.6226 25 36.1571 25Z",
    fill: color
  }));
};

IconWashingRoomFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconWashingRoomFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconWashingRoomFilled;
exports.default = _default;